module.exports = __webpack_public_path__ + "img/right-more-7.6b858412.png";